import { Back } from 'gsap';
import { TweenMax } from 'gsap';
import { Power0 } from 'gsap';
import Core from '../../../Core/Core';
import { createOutlineText } from '../../../Utils/Utils';
import { UIButton } from './UIButton';
import Point = PIXI.Point;
import Rectangle = PIXI.Rectangle;

export class PrizeWheelButton extends UIButton {
    public readonly icon: PIXI.Sprite;
    private text: PIXI.Text;
    constructor(state: boolean) {
        super('');
        const iconId = state ? 'mapui/prize-wheel-icon' : 'mapui/prize-wheel-icon-ad';
        this.icon = new PIXI.Sprite(PIXI.utils.TextureCache[iconId]);
        this.icon.anchor.set(0.5);

        this.text = createOutlineText(
            Core.local.getText('freespin'),
            new Rectangle(0, 0, this.icon.width * 1.1, this.icon.height),
            'Baloo',
            27,
            27
        );
        this.text.anchor.set(0.5, 0);
        this.text.x = this.width / 2;
        this.text.y = this.icon.height * 0.45;
        this.text.alpha = state ? 1 : 0;

        this.text.interactive = false;
        this.text.buttonMode = false;

        this.addChild(this.icon, this.text);
        this.alpha = 0;
    }

    public appear() {
        const scale = new Point(this.scale.x, this.scale.y);
        this.icon.scale.set(0);
        TweenMax.to(this, 0.2, { alpha: 1 });
        TweenMax.to(this.icon.scale, 0.5, {
            x: scale.x,
            y: scale.y,
            ease: Back.easeOut,
            onComplete: () => {
                if (this.parent) {
                    TweenMax.to(this.icon.scale, 0.7, {
                        delay: 0.5,
                        x: scale.x * 0.95,
                        y: scale.y * 0.95,
                        yoyo: true,
                        repeat: -1,
                        ease: Power0.easeNone,
                    });
                }
            },
        });
    }

    public cleanUp() {
        TweenMax.killTweensOf(this);
        TweenMax.killTweensOf(this.icon);
        TweenMax.killTweensOf(this.icon.scale);
    }

    public updateIcon(state: boolean) {
        const iconId = state ? 'mapui/prize-wheel-icon' : 'mapui/prize-wheel-icon-ad';
        this.icon.texture = PIXI.utils.TextureCache[iconId];
        this.text.alpha = state ? 1 : 0;
    }
}
